export default __webpack_public_path__ + "static/media/onboarding-finished.a3f96fb1.png";